const btnsToggleSmallPopin = document.querySelectorAll(
    ".js-toggle-small-popin"
);
const smallPopin = document.querySelector(".js-small-popin");

function initializeSliderSmallPopin() {
    if (document.querySelector(".js-tns-small-popin") !== null) {
        const smallPopinSlider = tns({
            container: ".js-tns-small-popin",
            items: 1,
            slideBy: 1,
            loop: true,
            autoplay: false,
            controls: false,
            center: true,
            gutter: 15,
            navPosition: "bottom",
        });
    }
}

if (btnsToggleSmallPopin.length > 0) {
    btnsToggleSmallPopin.forEach((_btn) => {
        _btn.addEventListener("click", (e) => {
            e.preventDefault();
            if (_btn.classList.contains("is-open")) {
                _btn.classList.remove("is-open");
                smallPopin.classList.remove("is-open");
            } else {
                _btn.classList.add("is-open");
                smallPopin.classList.add("is-open");
            }
        });
    });
}

if ($(".js-small-popin-cat-followed").length) {
    var tids = $(".js-small-popin-cat-followed").data("tids");
    //console.log(tids);
    $.ajax({
        url: wami_js.ajaxurl,
        data: {
            action: "wami_load_smallpopin_cat_followed",
            tids: tids,
        },
        success: function (data) {
            var obj = jQuery.parseJSON(data);
            //console.log(obj);
            $(".js-small-popin-cat-followed").html(obj.content);
            initializeSliderSmallPopin();
            lazyLoadInstance.update();
        },
        error: function (errorThrown) {
            console.log("erreur de chargement menu");
        },
    });
}
